import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
    const location = useLocation();
    const navigate = useNavigate();
    const { finalizeGoogleSession } = useAuth();
    const processed = useRef(false);

    useEffect(() => {
        if (processed.current) return;
        processed.current = true;

        const hash = location.hash || window.location.hash;
        const params = new URLSearchParams(hash.replace(/^#/, ""));
        const session_id = params.get("session_id");
        if (!session_id) {
            navigate("/login", { replace: true });
            return;
        }
        (async () => {
            try {
                const user = await finalizeGoogleSession(session_id);
                // Clear the hash and redirect
                window.history.replaceState(null, "", "/dashboard");
                navigate(user?.role === "admin" ? "/admin" : "/dashboard", { replace: true });
            } catch (e) {
                navigate("/login?error=oauth", { replace: true });
            }
        })();
    }, [finalizeGoogleSession, location.hash, navigate]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-bone" data-testid="auth-callback">
            <div className="text-center">
                <div className="eyebrow text-espresso mb-3">Finishing sign in</div>
                <div className="font-serif text-3xl text-ink">One moment…</div>
            </div>
        </div>
    );
}
